import { create } from 'zustand';

export type PlanFeaturesTrigger =
  | 'feature:glossary'
  | 'feature:lipsync'
  | 'feature:srt'
  | 'feature:subtitles'
  | 'feature:visual'
  | 'feature:voice_clone'
  | 'feature:voice_library'
  | 'playback';

export const usePlanFeaturesRequestStore = create<{ trigger: null | PlanFeaturesTrigger }>(() => ({ trigger: null }));

export const requestPlanFeaturesModal = (trigger: PlanFeaturesTrigger) =>
  usePlanFeaturesRequestStore.setState({ trigger });
